import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  timeSlot : null,
  timeSlots : [],
  error : null
};


export const TIME_SLOT_URL = "admin/time_slot";

export const createTimeSlot = createAsyncThunk(
    TIME_SLOT_URL + "/create",
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.post(TIME_SLOT_URL, formData);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

export const getTimeSlots = createAsyncThunk(
  TIME_SLOT_URL,
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(TIME_SLOT_URL);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getTimeSlotById = createAsyncThunk(
  TIME_SLOT_URL + "/get-by-id",
  async (id, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(TIME_SLOT_URL + "/get/" + id);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const updateTimeSlot = createAsyncThunk(
  TIME_SLOT_URL + "/update",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(TIME_SLOT_URL + "/update/" + formData?.id, formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

const timeSlotSlice = createSlice({
    name : "timeSlot",
    initialState,
    extraReducers : (builder) => {
        builder
            .addCase(createTimeSlot.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createTimeSlot.fulfilled, (state, action) => {
                state.isLoading = false;
                state.timeSlot = action.payload;
            })
            .addCase(createTimeSlot.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(updateTimeSlot.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(updateTimeSlot.fulfilled, (state, action) => {
                state.isLoading = false;
                state.timeSlot = action.payload;
            })
            .addCase(updateTimeSlot.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(getTimeSlots.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(getTimeSlots.fulfilled, (state, action) => {
                state.isLoading = false;
                state.timeSlots = action.payload;
            })
            .addCase(getTimeSlots.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(getTimeSlotById.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(getTimeSlotById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.timeSlot = action.payload;
            })
            .addCase(getTimeSlotById.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(logout, () => initialState)
    }
})

export default timeSlotSlice.reducer